/*
 * @Author: your name
 * @Date: 2022-11-19 11:14:05
 * @LastEditTime: 2022-12-16 17:02:41
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/pages/InductiveManage/DeployIng.tsx
 */
import React, { useState, useEffect, useRef } from 'react';
import { Button, Badge, Spin, Icon } from 'sup-ui';
import { useIntl } from 'react-intl';
import { getBindIngApi, clearNanotube } from 'root/services/nanotube';

import messages from './messages';

import styles from './index.less';
import { message } from 'sup-ui';

let loopTimer: any = null;
const supicon = <Icon type="loading" style={{ fontSize: 12 }} spin />;

const DeployIng = () => {
  const intl = useIntl();
  const [list, setList] = useState<any[]>([]);
  const [result, setResult] = useState(''); // 纳管结果
  const resutRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    getList();
    return () => {
      clearTimeout(loopTimer);
    };
  }, []);

  // 论询
  const loopGetData = () => {
    loopTimer = setTimeout(() => {
      getList();
    }, 1000 * 5);
  };

  const getList = () => {
    if (loopTimer) {
      clearTimeout(loopTimer);
    }

    getBindIngApi().then((res: any) => {
      const {
        data: { itemList, result },
      } = res;

      setList(itemList);
      setResult(result);

      if (!result) {
        loopGetData();
        return;
      }

      // 让检测结果显示滚动到视口
      if (resutRef?.current) {
        resutRef.current.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }
      // 纳管完成,清空本次纳管
      clearNanotube();
      if (result === 'SUCCESS') {
        message.success(intl.formatMessage(messages.nanotubeSuccess));
        window.location.href = '/envManage';
      }
    });
  };

  return (
    <div className={styles.deploying}>
      <div className={styles.content}>
        {/* <Badge className={styles.success} color='blue' text="1111" />
      <Badge className={styles.error} color='blue' text="222" /> */}

        {list.map((item) => {
          const { status, description } = item;
          return status === 'NOT_CHECK' ? (
            <div className={styles.checking}>
              <Spin indicator={supicon} className={styles.loading} />
              {description}
            </div>
          ) : (
            <Badge
              key={item}
              className={styles[status]}
              color={status === 'UN_PASS' ? 'red' : 'blue'}
              text={description}
            />
          );
        })}
        {result === 'FAILED' && (
          <div className={styles.result} ref={resutRef}>
            {intl.formatMessage(messages.nanotubeFail)}:
            <span className={styles.downloadFail}>{intl.formatMessage(messages.downloadNanotubeFail)}</span>
          </div>
        )}
      </div>
      <div>
        {result === 'FAILED' ? (
          <Button type="primary">{intl.formatMessage(messages.reNanotube)}</Button>
        ) : (
          <Button type="primary" className={styles.anotubeBtn}>
            {intl.formatMessage(messages.deployIng)}
          </Button>
        )}

        <Button disabled={result !== 'FAILED'}>{intl.formatMessage(messages.deployCancel)}</Button>
      </div>
    </div>
  );
};

export default DeployIng;
